import PropTypes from 'prop-types';
import React from 'react';

export default function Cell({className, ariaLabel, children, role}) {
    return (
        <div className={'ob-comparison-chart-cell ' + className} role={role} aria-label={ariaLabel}>{children}</div>
    );
}

Cell.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    role: PropTypes.string,
    ariaLabel: PropTypes.string
}